import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

interface CurrentUser {
  role: 'owner' | 'admin' | 'sales' | 'member';
  visibilityPolicy: 'restricted' | 'team-visible' | 'open';
  profileId: string | null;
  email: string | null;
  name: string | null;
}

export function useCurrentUser() {
  const { data, isLoading } = useQuery({
    queryKey: ['current-user'],
    queryFn: () => apiFetch<CurrentUser>('/me'),
    staleTime: 5 * 60 * 1000
  });

  const user = data?.data ?? null;

  return {
    role: user?.role ?? 'member',
    policy: user?.visibilityPolicy ?? 'team-visible',
    profileId: user?.profileId ?? null,
    isLoading,
    canAccessAdmin: user?.role === 'owner' || user?.role === 'admin',
    canAccessSales: user?.role !== 'member',
    canAccessTeam:
      user?.role !== 'member' ||
      user?.visibilityPolicy === 'team-visible' ||
      user?.visibilityPolicy === 'open',
    canAccessMarketInsights: user?.role !== 'member' || user?.visibilityPolicy === 'open'
  };
}

export type { CurrentUser };
